<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logohome.png" class="mt-5" style="width:400px">
    <h1 class ="mt-4">Bienvenue sur Sivercoh</h1>
    <p>Le Système d'Information développé
      pour Vérifier la Cohérence des données</p>
  </div>
</template>

<script>

export default {
  name: 'HomePage',
}
</script>

